<template lang="pug">
  - $image_path = '@/assets/images/campaign/';
  .page-campaign
    CloseButton
    transition(name="slidein" appear)
      .inner
        .textarea
          h2.textarea-title 5月29日は幸福の日
          .textarea-text
            | こう（5）ふく（29）の語呂合わせで、5月29日に「幸せ（ハッピー）がお客様に戻って来る（ターン）ように」と願いをこめて生まれた「ハッピーターン」ブランドが皆様に幸せをお裾分けするお手伝いをします。世界中の人々がハッピーなりますように！と願いをこめ、「ハッピーターン」ブランドのターン王子が活躍します。
        p.image-frame: img(src=`${$image_path}image_content.png`)
</template>

<script>
import CloseButton from '@/components/CloseButton';

import SoundController from '@/assets/js/SoundController';

export default {
  name: 'Campaign',
  components: {
    CloseButton
  }
};
</script>

<style scoped lang="scss">
.page-campaign {
  padding: vw(85) 0;
  background: image-url('common/bg_castle.png') no-repeat
    map-get($primary_color, 'grass');
  background-size: 100% auto;
  .inner {
    position: relative;
  }
  .textarea {
    position: absolute;
    top: vw(2170);
    left: vw(140);
    width: vw(1000);
    &-title {
      margin-bottom: vw(70);
      font-size: vw(60);
      font-weight: bold;
      text-align: center;
    }
    &-text {
      margin-bottom: vw(70);
      font-size: vw(44);
      line-height: 1.6;
      text-align: left;
    }
  }
  .button-campaign {
    display: block;
    width: vw(816);
    margin: 0 auto;
  }
  .image-frame {
    width: vw(1218);
    margin: 0 auto;
  }
}
</style>
